export class CaosConfigurationHistory {
    id: number;
    installationName: string;
    templateName: string;
    updateDate: Date;
    resultCode: number;
    errorDetails: string;
    isBackup: boolean = false;
    backupRestoredDate: string = null;

    public parse(obj: any) {
        if (obj.Id) this.id = obj.Id;
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.TemplateName) {
            this.templateName = obj.TemplateName;
            if (this.templateName.includes("@@Backup restore@@")) {
                this.isBackup = true;
                if (this.templateName.split(";").length == 2) this.backupRestoredDate = this.templateName.split(";")[1];
            }
        }
        if (obj.UpdateDate) this.updateDate = obj.UpdateDate;
        if (obj.ResultCode) this.resultCode = obj.ResultCode;
        if (obj.ErrorDetails) this.errorDetails = obj.ErrorDetails;
    }
}
